












































import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import BuilderDeviceHighlight from '@/components/builder/BuilderDeviceHighlight.vue'

@Component({
  components: {
    BuilderDeviceHighlight,
  },
  computed: {
    ...mapGetters('builder', { appType: 'getAppType' }),
  },
})
export default class BuilderDeviceProfileContentTypeStub extends Vue {
  @Prop({ required: true, type: String }) color!: string

  @Prop({ default: false, type: Boolean }) blur!: boolean

  @Prop({ default: false, type: Boolean }) highlight!: boolean

  appType!: string

  get isActivePosts(): string {
    if(this.appType === 'TYPE_STORE' && !this.isStepPosts) {
      return 'text-crm-20'  
    }
    return 'text-black'
  }
  get isActiveShop(): string {
    if(this.appType === 'TYPE_STORE' && !this.isStepPosts) {
      return 'text-black'
    }
    return 'text-crm-20'
  }
  get navIconPosts(): string {
    return require('@/assets/images/crm/svg/post-icon.svg')
  }
  get navIconStore(): string {
    if(this.appType === 'TYPE_STORE' && !this.isStepPosts) {
      return require('@/assets/images/crm/svg/shop-icon-black.svg')
    }
    return require('@/assets/images/crm/svg/shop-icon.svg')
  }
  get navIconPhoto(): string {
   if(this.appType === 'TYPE_BLOGER' || this.isStepPosts) {
      return require('@/assets/images/crm/svg/photo-device-icon-black.svg')
    }
    return require('@/assets/images/crm/svg/photo-device-icon.svg')
  }
  get isStepPosts(): boolean {
    if(this.$route.name === 'profile.create_post') {
      return true  
    }
    return false
  }
}
